import React from 'react';
import { usePricing } from '../context/PricingContext';
import IntroductionSection from './IntroductionSection';
import TabNavigation from './TabNavigation';
import ProcessCards from './ProcessCards';
import PricingCard from './PricingCard';
import { pricingPlans } from '../data/mock';

const PricingSection = ({ onGetStarted }) => {
  const { activePricingTab } = usePricing();

  // Pricing datasets for each tab
  const selfFilingPlans = [
    {
      id: 1,
      name: "Essentials",
      price: "$45",
      federal: "+ Federal Filing Fee",
      features: [
        "Case Review",
        "Case Filing",
        "Basic Search",
        "State E-Filing",
        "Trademark Secured"
      ],
      note: "",
      recommended: false,
      paymentNotice: "Simple guided process with expert support at every step to ensure accuracy"
    },
    {
      id: 2,
      name: "Enhanced",
      price: "$149",
      federal: "+ Federal Filing Fee",
      features: [
        "Case Review",
        "Case Filing",
        "Direct Hit Search",
        "Trademark Alert",
        "Trademark Secured",
        "High Satisfaction Rate",
        "Refusal Risk Meter"
      ],
      note: "",
      recommended: false,
      paymentNotice: "Balanced assistance that helps you move forward with clear professional direction"
    },
    {
      id: 3,
      name: "Deluxe",
      price: "$299",
      federal: "+ Federal Filing Fee",
      features: [
        "Case Review",
        "Case Filing",
        "Direct Hit Search",
        "Trademark Alert",
        "Trademark Secured",
        "High Satisfaction Rate",
        "Refusal Risk Meter",
        "Trademark Monitoring",
        "Complete Documentation",
        "Digital File",
        "Dedicated Case Manager"
      ],
      note: "",
      recommended: true,
      paymentNotice: "Advanced support with deeper planning, careful review, and ongoing clarity"
    },
    {
      id: 4,
      name: "Platinum",
      price: "$349",
      federal: "+ Federal Filing Fee",
      features: [
        "Case Review",
        "Case Filing",
        "Direct Hit Search",
        "Trademark Alert",
        "Trademark Secured",
        "High Satisfaction Rate",
        "Refusal Risk Meter",
        "Trademark Monitoring",
        "Complete Documentation",
        "Digital File",
        "Dedicated Case Manager",
        "High Approval Rate",
        "Comprehensive Search Report",
        "High Priority Service",
        "Cease & Desist Letter"
      ],
      note: "",
      recommended: false,
      paymentNotice: "Premium guided service with expert attention, leadership, and complete confidence"
    }
  ];

  const attorneyLedPlans = [
    {
      id: 5,
      name: "BASIC",
      price: "$795",
      federal: "Govt. filing fee not included",
      features: [
        "Attorney-Handled Trademark Filing from Start to Finish",
        "Professional Case Evaluation",
        "Application Preparation & Submission",
        "Preliminary Trademark Search",
        "State-Level E-Filing Included",
        "Attorney-Handled Trademark Filing from Start to Finish",
        "Professional Case Evaluation",
        "Application Preparation & Submission",
        "Preliminary Trademark Search",
        "State-Level E-Filing Included"
      ],
      note: "",
      recommended: false,
      paymentNotice: "Reliable professional support for a smoother and more confident filing process"
    },
    {
      id: 6,
      name: "STANDARD",
      price: "$895",
      federal: "Govt. filing fee not included",
      features: [
        "Attorney-Led Trademark Filing",
        "End-to-End Case Handling",
        "Comprehensive Case Review & Analysis",
        "Professional Application Preparation",
        "Trademark Secured",
        "USPTO-Compliant Filing Process",
        "Attorney-Led Trademark Filing",
        "End-to-End Case Handling",
        "Comprehensive Case Review & Analysis"
      ],
      note: "",
      recommended: true,
      paymentNotice: "Guided step-by-step assistance with added care, clarity, and peace of mind"
    },
    {
      id: 7,
      name: "DELUXE",
      price: "$1,145",
      federal: "Govt. filing fee not included",
      features: [
        "Attorney-Led Case Review",
        "Complete Case Filing & Management",
        "Advanced Direct-Hit Trademark Search",
        "Trademark Monitoring & Alerts",
        "Comprehensive Risk & Refusal Meter",
        "Attorney-Led Case Review",
        "Complete Case Filing & Management",
        "Advanced Direct-Hit Trademark Search",
        "Trademark Monitoring & Alerts",
        "Comprehensive Risk & Refusal Meter"
      ],
      note: "",
      recommended: false,
      paymentNotice: "Organized service with expert review, careful preparation, and steady progress"
    },
    {
      id: 8,
      name: "PLATINUM",
      price: "$1,545",
      federal: "Government filing fee included",
      features: [
        "Attorney-Led Case Review & Strategy",
        "Complete Case Filing & Management",
        "Advanced Direct-Hit Trademark Search",
        "Federal & State Trademark Search Report",
        "Trademark Monitoring & Real-Time Alerts",
        "Attorney-Led Case Review & Strategy",
        "Complete Case Filing & Management",
        "Advanced Direct-Hit Trademark Search",
        "Federal & State Trademark Search Report",
        "Trademark Monitoring & Real-Time Alerts"
      ],
      note: "",
      recommended: true,
      paymentNotice: "Priority support with focused attention, quicker handling, and greater confidence"
    }
  ];

  const currentPlans = activePricingTab === 1 ? selfFilingPlans : attorneyLedPlans;
  const sectionTitle = activePricingTab === 1 
    ? 'Self-Filing with Expert Assistance<br />Complete Support Plan for Easy Filing' 
    : 'Attorney-Led Filing<br />Complete End-to-End Service Plan';

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <IntroductionSection />
        <TabNavigation />
        <ProcessCards activeTab={activePricingTab} />
        
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4" dangerouslySetInnerHTML={{ __html: sectionTitle }}>
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {currentPlans.map((plan) => (
            <PricingCard
              key={plan.id}
              plan={plan}
              paymentNotice={plan.paymentNotice}
              onGetStarted={onGetStarted}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;